import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#E31D1C"
          fillRule="evenodd"
          d="M0 0v6h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F1F9FF"
          d="M1.926 3.187c0-2.108 1.822-2.263 2.508-2.09 0 0-1.412.55-1.413 2.09 0 1.54 1.413 2.108 1.413 2.108-.714.397-2.508 0-2.508-2.108Zm3.47 1h.455l-.337.375.102.478-.414-.244-.405.244.091-.478-.336-.357.457-.018.193-.447.193.447Zm1.472-.028h.456l-.336.376.1.478-.413-.244-.406.244.093-.478-.338-.357.457-.019.194-.446.193.446Zm-1.99-1.157h.457l-.337.377.101.477-.414-.245-.405.245.092-.477-.337-.358.457-.02.193-.445.194.446Zm2.68-.023h.455l-.336.377.101.478-.414-.244-.405.244.093-.478L6.714 3l.457-.02.193-.445.193.445Zm-1.316-.948h.457l-.337.376.102.478-.415-.244-.406.244.093-.478-.338-.357.457-.019.194-.446.193.446Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
